import * as React from 'react';
import classnames from 'classnames';
import { TypeIconName } from '../Icon/tsx';
import dataAtIds from '../dataAtIds.json';
import Base, { Props as BaseProps } from '../Base/Base';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import { SidebarMenuContext } from './SidebarMenuContext';
import Visibility from '../Visibility/Visibility';
import VisibilityContainer from '../Visibility/VisibilityContainer';

const { useContext } = React;

export interface Props extends BaseProps {
  /**
   * Name of an icon (from the Icon component) that should
   * appear next to the text.
   */
  icon?: TypeIconName;
}

/**
 * Child of the SidebarMenu component that is used to handle the
 * navigation when interacted with.
 */
const SidebarMenuItem: React.FunctionComponent<Props> = (props: Props) => {
  const { children, icon, ...rest } = props;
  const { active, hasSubMenu } = useContext(SidebarMenuContext);
  const classes = classnames('Sidebar__menu-item', {
    'Sidebar__menu-item--active': active,
  });

  return (
    <Base className={ classes } padding="x1">
      <VisibilityContainer { ...rest }
          alignChildrenVertical="middle"
          className="Sidebar__menu-item-link"
          data-bitkit-at-id={ dataAtIds.SidebarMenuLink }
          direction="horizontal"
          enabled={ !active }
          gap="x4">
        { icon && (
          <Flex>
            <Icon name={ icon } />
          </Flex>
        ) }

        <Flex grow initial="none">
          { children }
        </Flex>

        { hasSubMenu && (
          <Visibility>
            <Icon name="ChevronDown" />
          </Visibility>
        ) }
      </VisibilityContainer>
    </Base>
  );
};

SidebarMenuItem.defaultProps = {
  Component: 'a',
};

export default SidebarMenuItem;
